/* eslint-disable func-names, max-len, no-new, no-plusplus, no-shadow, no-underscore-dangle, no-console */
import $ from 'jquery';

const $showHideSection = $('.js-table-section');
const $showHideArea = $('.js-show-hide-content');
const $showHideBtn = $('.js-show-hide-btn');

if ($showHideArea.length > 0) {
  $showHideBtn.on('click tap', (e) => {
    const $this = $(e.currentTarget);
    $this.toggleClass('is-active');

    $this.parents($showHideSection).find($showHideArea).slideToggle();
  });
}



// WEBPACK FOOTER //
// ./js/components/init-show-hide.js